module.exports = __webpack_public_path__ + "static/img/webg.353af87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/webg.png
// module id = sFI6
// module chunks = 1